module.exports = __webpack_public_path__ + "media/bootstrap-icons/safe-fill-80bd05f2.svg";